import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { Alert, Tag, Tooltip } from 'antd';

/**
 * Prominent error banner shown when the hosted BIMI logo fails the
 * certificate hash check. Renders nothing unless the check ran and failed.
 */
export const LogoIntegrityAlert = ({ logoValidation, style }) => {
  if (!logoValidation || logoValidation.valid !== false) return null;

  return (
    <Alert
      type="error"
      showIcon
      message="Your BIMI logo does not match your mark certificate"
      description={
        <>
          The SVG hosted at your BIMI record&apos;s <code>l=</code> URL is not the logo certified
          in your VMC/CMC — its SHA hash does not match the hash embedded in the certificate.
          Mailbox providers verify this and will not display your logo (or blue checkmark) until
          the hosted file is replaced with the exact SVG that was certified.
        </>
      }
      style={{ marginBottom: '24px', textAlign: 'left', ...style }}
    />
  );
};

/**
 * Displays whether the hosted BIMI logo matches the logo certified in the
 * mark certificate (VMC/CMC logotype extension hash, RFC 9399).
 * Renders nothing when the backend did not provide a logoValidation result.
 */
export const LogoIntegrityTag = ({ logoValidation }) => {
  if (!logoValidation) return null;

  if (logoValidation.valid === true) {
    return (
      <Tooltip title="The SVG hosted at the BIMI l= URL matches the logo certified in the mark certificate.">
        <Tag color="green" icon={<CheckCircleOutlined />}>
          Matches certificate
        </Tag>
      </Tooltip>
    );
  }

  if (logoValidation.valid === false) {
    return (
      <Tooltip
        title={
          logoValidation.reason ||
          'The hosted BIMI logo does not match the logo certified in the mark certificate.'
        }
      >
        <Tag color="red" icon={<CloseCircleOutlined />}>
          Does not match certificate
        </Tag>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={logoValidation.reason || 'Logo integrity could not be verified.'}>
      <Tag color="default" icon={<QuestionCircleOutlined />}>
        Not verified
      </Tag>
    </Tooltip>
  );
};
